import React, { Component } from 'react';
import _ from 'lodash';
import {Table, Pagination, FormControl } from 'react-bootstrap';


function searchingFor(filterRows){
	return function(x){
      let key = _.keys(filterRows)
      let newObj =[]
      if(!_.isEmpty(key)){        
       _.map(key, (gg) =>{  
        if(!_.isNull(x[gg])){
          if(typeof x[gg] === "string"){
            newObj.push(x[gg].toLowerCase().includes(filterRows[gg].toLowerCase()))
          } else {
            newObj.push(x[gg].toString().includes(filterRows[gg].toString()))
          }
        }
      })
    }
    if(!_.isEmpty(newObj)){
      return !_.includes(newObj, false)
    } else {
       return true
    }
  }
}
export default class ReportViewNPS extends Component {
  constructor(props){
    super(props)
    this.state= {
      activePage: 1,
      orderBy:"asc",
      showFilter:false,
      filterRows: {}
    }
   }
   UNSAFE_componentWillMount(){
    this.setState({reportData:this.props.reportData})
   }
   UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props.reportData, nextProps.reportData)){
      this.setState({reportData:nextProps.reportData})
    }

  }

  handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
  }
  handleSort = (column) => {
    const {orderBy, reportData} = this.state 
    let alphaRegex = ".*[A-Z].*";    
    var data = _.orderBy(reportData.value.values, row => {
      let value = _.get(row, column)
      if(!_.isNull(value) && typeof value !== 'undefined'){
        if(value.toString().match(alphaRegex)){
          return value != null ? value.toString().toLowerCase() : ''
        } else {
        return value != null ? parseInt(value) : ''
        }   
      }   
   }, orderBy)
    reportData.value.values = data
    this.setState({reportData})
    if(orderBy === "asc"){
     this.setState({orderBy:"desc"})
    } else {
     this.setState({orderBy:"asc"})
    }
  } 
  handleFilter = () =>{
    this.setState((prevState) =>{
      return {showFilter: !prevState.showFilter};
    })
    if(!_.isNull(this.state.filterRows)){
      let keys = _.keys(this.state.filterRows)
      _.map(keys, (obj) =>{
        this.setState({[obj]:""})
      })
      this.setState({filterRows:{}})
    }
  }
  handleChange = (e) => {
    const {filterRows} = this.state
    let filterCol = filterRows
    if(_.has(filterCol, e.target.id)){
      filterCol[e.target.id]  = e.target.value
    } else {
      filterCol = Object.assign(filterCol, {[e.target.id]:e.target.value})
    }
    this.setState({[e.target.id]:e.target.value, filterRows:filterCol})	
  }
  mapDatabodyData = (data, startOffset, startCount, Per_Page, subHeaders, fields, filterfield) =>{
    const {filterRows} = this.state
    let returnObj=[];
    _.map(data.filter(searchingFor(filterRows)), (xx, index)=> {
      if(index >= startOffset & startCount < Per_Page){
        startCount++;            
        returnObj.push(                     
      (!_.isEmpty(subHeaders))?                       
      <tr>
        {_.map(subHeaders, (dd) => {          
          return <td>{xx[dd.value]}</td>;
        })}
      </tr>

      :
      <tr>
      {_.map(fields, (dd) => {
           return <td>{xx[dd.value]}</td>;
      })}
    </tr> 
      );
    }
  })
  if(this.state.showFilter === true){
    returnObj.unshift(<tr>{filterfield}</tr>)
  }
  return returnObj
  }
 
  render(){
    const{activePage, reportData,} = this.state; 
    const Per_Page=20;
		let totalPages = 1
		const startOffset = (this.state.activePage-1) * Per_Page;
		let startCount = 0;
    let items = [];
    
    if(!_.isEmpty(reportData) && !_.isEmpty(reportData.value)){
      totalPages = Math.ceil(reportData.value.values.length/Per_Page)
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
      }
    }
  
    let subHeaders=[];
    let fields=[];
    let length=1;
    //let headerLength = 1;
    let filterfield=[]
    return(
    <div className="reportDataView" >
      {(!_.isEmpty(reportData) && !_.isEmpty(reportData.value) && !_.isEmpty(reportData.value.values)) ?
      <div>
        <Table responsive striped bordered>
        <thead>
        <tr>
            {_.map(reportData.header, (obj, index) => {
             //  headerLength = reportData.header.length
                if(_.has(obj, "subHeaders")  && !_.isEmpty(obj.subHeaders)){
                  length = obj.subHeaders.length
                _.map(obj.subHeaders, (tt) => {               
                  subHeaders.push(tt)
                  filterfield.push(<td><FormControl
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                    id={tt.value}
                    onChange={(e) => this.handleChange(e)}
                    value={this.state[tt.value]}
                    /></td>) 
                })
              } else {
                fields.push(obj)
                filterfield.push(<td><FormControl
                  placeholder="Search"
                  aria-label="Search"
                  aria-describedby="basic-addon1"
                  id={obj.value}
                  onChange={(e) => this.handleChange(e)}
                  value={this.state[obj.value]}
                  /></td>) 
              }
              return <th colSpan={length}>
              {index === 0 ? <i class="fas fa-filter filterReport" onClick={this.handleFilter}/> : null}  
              {obj.label.toUpperCase()}</th>;
            })}
          </tr>
          {(!_.isEmpty(subHeaders))?
          <tr className="dualheaders">
            {_.map(subHeaders, obj => {
              return <th>{obj.label.toUpperCase()}&nbsp;<i class="fas fa-sort" onClick={()=>this.handleSort(obj.value)}/></th>;
            })}
          </tr> : null }
        </thead> 
        <tbody>
           {(!_.isEmpty(reportData.value)) ?
           (!_.isEmpty(reportData.value.values)) ?
           this.mapDatabodyData(reportData.value.values, startOffset, startCount, Per_Page, subHeaders, fields, filterfield) 
          //  _.map(reportData.value.values.filter(searchingFor(filterRows)), (xx, index)=> {
          //   	if(index >= startOffset & startCount < Per_Page){
					// 			startCount++;
          //   return (
          //     (!_.isEmpty(subHeaders))?
          //     <tr>
          //       {_.map(subHeaders, dd => {
          //         return <td>{xx[dd.value]}</td>;
          //       })}
          //     </tr>   
          //     :
          //     <tr>
          //     {_.map(fields, dd => {
          //       return <td>{xx[dd.value]}</td>;
          //     })}
          //   </tr> 
          //     );
          //   }
          // }) 
          :<tr><td colSpan={length}>No Record Found</td></tr>
          :<tr><td colSpan={1}>No Record Found</td></tr>
        
        }          
          {(_.has(reportData, "grandTotal") && !_.isNull(reportData.grandTotal))  ?
          <tr>
          {_.map(reportData.grandTotal, (obj)=> {
            return( <th>{obj.value}</th>  )
            }) 
          }
          </tr>  : null } 
        </tbody>
      </Table>
      <br/>
      <Pagination>
				<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
				<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
            {items[activePage-1]}
            {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
            {items[activePage+1]}
				<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
				<Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
				</Pagination>
      </div> :
      <Table responsive bordered className='marginTop'><tbody>
        <tr><td>No Records Found</td></tr></tbody></Table>}
    
    
    </div>)
  }
}